// Constant Data for Seller::Inbound::InventoryBatch

// photo studio location of a batch, dependant on backend changes
export const PHOTO_STUDIO_LOCATION = {
  SMALL_STUDIO : 'small_studio',
  BIG_STUDIO   : 'big_studio'
}

// status of a batch, dependant on backend changes
export const STATUS = {
  PENDING               : 'pending',
  PHOTO_STUDIO_RECEIVED : 'photo_studio_received',
  PHOTOGRAPHY_COMPLETE  : 'photography_complete',
  WAREHOUSE_RECEIVED    : 'warehouse_received',
  PUT_AWAY_COMPLETE     : 'put_away_complete',
  PUT_AWAY_PARTIAL      : 'put_away_partial'
}

// photo edit status of a batch
export const PHOTO_EDIT_STATUS = {
  PENDING  : 'pending',
  COMPLETE : 'complete'
}

// static code, no relation with backend
export const PROCESS_STATUS = {
  PHOTO_STUDIO : 'photo_studio',
  WAREHOUSE    : 'warehouse',
  PHOTO_EDITOR : 'photo_editor'
}